import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import OutsideClickHandler from 'react-outside-click-handler';
import { Block, Label, Tag, Text } from '../..';
import CardHelpers from '../../../../core/helpers/CardHelper';
import CourseDetail from './CourseDetail';
import iconCanvas from '../../../../assets/icons/home/casuisticas/virtual.svg';
import iconMapping from '../../../../assets/icons/mappin.svg';
import iconMappinDark from '../../../../assets/icons/home/dark/mappin.svg';
import iconPresencial from '../../../../assets/icons/home/casuisticas/map-pin.svg';
import iconRemoto from '../../../../assets/icons/iconRemoto.svg';
import iconRemoteDark from '../../../../assets/icons/home/dark/remote.svg';
import iconRemotoZoom from '../../../../assets/icons/remoto-zoom-canvas.svg';
import LaptopImage from '../../../../assets/icons/laptop2.svg';
import {
  CardCourseElement,
  TopDataInfo,
  TopDataInfo2
} from './styled/CardCourseStyled';
import { GlobalStyles } from '../../LightBox';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

interface Props {
  contentData?: any;
  isReprogramming?: boolean;
  cardType?: any;
  dateEvent: any;
  id: any;
  handleOpenModalDetail: () => void;
  handleCloseModalDetail: () => void;
  handleContentModalDetail: (content: any) => void;
}

export const cardLocation = (
  type: any,
  classRoomId: any,
  modality: string,
  classroom?: string
) => {
  switch (type) {
    case 'E':
      return modality === 'P' ? classRoomId : 'Zoom';
    case 'P':
      return classRoomId;
    case 'C':
      return 'Zoom'; // se reemplaza Canvas + Zoom por Zoom
    case 'A':
      return modality === 'P' ? '' : 'Zoom';
    case 'R':
      return modality === 'P' ? classroom : 'Zoom';
    default:
      return '';
  }
};

export const imageLocation = (type: any) => {
  switch (type) {
    case 'E':
      return iconCanvas;
    case 'P':
      return iconPresencial;
    case 'C':
      return iconRemotoZoom;
    default:
      return '';
  }
};
export const cardIcon = (type: any, modality: any) => {
  switch (type) {
    case 'P':
      return iconMapping;
    case 'C':
      return iconRemoto;
    case 'A':
      return modality === 'P' ? iconMappinDark : iconRemoteDark;
    case 'R':
      return modality === 'P' ? iconMappinDark : iconRemoteDark;
    case 'E':
      return modality === 'P' ? iconMappinDark : iconRemoteDark;
    default:
      return LaptopImage;
  }
};

const CardCourse = (props: Props) => {
  const {
    contentData,
    isReprogramming,
    cardType,
    dateEvent,
    id,
    handleOpenModalDetail,
    handleCloseModalDetail,
    handleContentModalDetail
  } = props;

  const history = useHistory();

  const content = CardHelpers.getCardProcessed(
    cardType,
    contentData,
    dateEvent
  );

  const textLocation = cardLocation(
    contentData?.type,
    contentData?.location?.classRoom?.id,
    contentData.modality,
    contentData.classroomCode
  );

  const [detailShow, setDetailShow] = useState(false);
  const handelOut = () => {
    if (!isMobile) {
      setDetailShow(false);
    }
  };

  const handleIn = () => {
    if (['P', 'C'].includes(cardType)) {
      GoogleAnalytics.writeLog('portal-schedule-courseCard', 'schedule');
    }
    if (cardType === 'A') {
      history.push(
        `/servicios/eventos/Inscritos/detalle/${contentData?.eventId}`
      );
      return;
    }

    if (cardType === 'R') {
      history.push(`/servicios/refuerzo-academico/${contentData?.eventId}`, {
        courseId: 'byCalendar'
      });
      return;
    }

    if (isMobile) {
      handleContentModalDetail(
        <CourseDetail
          className="DetailCard"
          contentData={contentData}
          onClose={handleCloseModalDetail}
          cardType={cardType}
          dateEvent={dateEvent}
          isReprogramming={isReprogramming}
        />
      );
      handleOpenModalDetail();
    } else {
      setDetailShow(true);
    }
  };
  const getClassName = (cssClass: any, isrep: any) => {
    let classStyle = 'cardContent fadeTransition ';
    if (isrep) {
      classStyle += ' clsReprog';
    }

    return classStyle;
  };

  return (
    <CardCourseElement
      data-testid="cmp-card-course-element"
      id={`order-${contentData.order}-event-${id}`}
      color={isReprogramming ? '#bee9e4' : content?.summary?.background}
      top={content?.summary?.position?.top}
      height={content?.summary?.position?.height}
      // className={getClassName(
      //   content?.summary?.position?.cssclass,
      //   isReprogramming
      // )}
      width={content.summary?.position?.width}
      left={content.summary?.position?.left}
      isReprog={isReprogramming}
      cardType={cardType}
      showIcon={content?.icon}
    >
      <button
        data-testid="cmp--btn-card-course-element"
        type="button"
        className={getClassName(
          content?.summary?.position?.cssclass,
          isReprogramming
        )}
        // className="cardContent fadeTransition"
        style={{
          height: content?.summary?.position?.height,
          position: 'relative',
          width: '100%'
        }}
        onClick={handleIn}
      >
        <Block
          style={{
            width: '100%',
            padding: isReprogramming ? '6px 0px 4px 4px' : '2px 4px'
          }}
          customized
        >
          <TopDataInfo
            height={content?.summary?.position?.height}
            className="lastLine"
          >
            {!['A', 'R', 'E'].includes(contentData.type) && (
              <Tag
                backgroundColor={content?.tag?.background}
                color={content?.tag?.color}
                // padding="2px 10px"
                padding="4px 12px"
                black
                radius={20}
                className="tagFontSize"
              >
                <span
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontWeight: '700',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {content?.tag?.label}
                </span>
              </Tag>
            )}
          </TopDataInfo>
          <TopDataInfo className={content?.summary?.styleClassTitle}>
            <Label
              black
              size={12}
              text={content?.summary?.title ?? ''}
              fontWeight="black"
              lineHeight={16}
              className="titleFontSize"
              color={content.textColor}
            />
          </TopDataInfo>
          <TopDataInfo2>
            <Label
              size={10}
              text={content?.summary?.hour ?? ''}
              className="hourFontSize"
              color={content.textColor}
            />
            {/* {isMobile &&
                    isReprogramming &&
                    content?.summary?.position?.width === 100 && (
                      <TagRescheduled
                        isRescheduled
                        colorProp={content.textColor}
                      />
                    )} */}
          </TopDataInfo2>
          <TopDataInfo
            height={content?.summary?.position?.height}
            className="lastLine"
          >
            <Block flex>
              {content?.icon ? (
                <>
                  <img
                    alt=""
                    src={cardIcon(cardType, contentData?.modality)}
                    height="20"
                    style={{ marginRight: 7 }}
                  />
                  {content?.summary?.position?.width === 100 && (
                    <>
                      {contentData.isHybrid && (
                        <Text
                          color={content.textColor}
                          fontWeight="normal"
                          style={{ whiteSpace: 'pre' }}
                          data-testid="cmp--text-techlink"
                        >
                          {'TechLink - '}
                        </Text>
                      )}
                      <Text
                        color={content.textColor}
                        fontWeight="700"
                        style={{ display: 'flex', alignItems: 'center' }}
                        fontSize="12px"
                      >
                        {textLocation}
                      </Text>
                    </>
                  )}
                </>
              ) : (
                <></>
              )}
            </Block>
          </TopDataInfo>
        </Block>
      </button>
      {!isMobile && detailShow && (
        <>
          <GlobalStyles />
          <div
            style={{
              background: 'rgb(40 48 68 / 60%)',
              position: 'fixed',
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              zIndex: 99,
              height: '100%'
            }}
          >
            <OutsideClickHandler onOutsideClick={handelOut}>
              <CourseDetail
                className="sidebarCard"
                contentData={contentData}
                onClose={handelOut}
                cardType={cardType}
                dateEvent={dateEvent}
                isReprogramming={isReprogramming}
              />
            </OutsideClickHandler>
          </div>
        </>
      )}
    </CardCourseElement>
  );
};

CardCourse.defaultProps = {
  contentData: {},
  isReprogramming: false,
  cardType: 'C'
};

export default CardCourse;
